import { getRandomColorCode } from "./random";
import { parseStringifiedJsonObj } from "./object.js";

export const persistAvatars = (userIds) => {
  const avatars = JSON.parse(localStorage.getItem("avatars")) || {};
  userIds &&
    userIds.forEach((userId) => {
      if (!avatars.hasOwnProperty(userId)) {
        avatars[userId] = getRandomColorCode();
      }
    });
  localStorage.setItem("avatars", JSON.stringify(avatars));
};

export const getAvatarColor = (avatarId) => {
  const avatars = JSON.parse(localStorage.getItem("avatars"));
  return avatars && avatars[avatarId];
};

export const getCookie = (cname) => {
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(";");
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
};

export const setCookie = (cname, cvalue, exdays) => {
  const d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  let expires = "expires=" + d.toUTCString();
  if (process.env.NODE_ENV === "production") {
    document.cookie = cname + "=" + cvalue + ";" + expires;
  } else {
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  }
};

/**
 * This funtion clears status of popup that is saved in localstorage based on the setting
 *
 * @param {string} popupName - name identifier that popup is saved by in localstorage
 * @param {boolean} savedByObject - some popup's status are saved by a simple boolean and some are saved in an object form (like popups with pagination)
 * @returns
 */
export const changePopupStatusByLogout = (popupName, savedByObject = false) => {
  let status;

  const savedInLocal = localStorage.getItem(popupName);
  if (savedByObject) {
    const obj = parseStringifiedJsonObj(savedInLocal);

    status = obj?.status;
  } else {
    status = savedInLocal;
  }

  if (status !== "never") {
    localStorage.removeItem(popupName);
    return;
  }
};
